import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { FeatureProductModule }  from '@unpispas/feature/product';
import { FeaturePeriodModule } from '@unpispas/feature/period';

import { UppOfferThumbComponent } from '../components/thumb/upp-thumb';
import { UppOfferTicketComponent } from '../components/ticket/upp-ticket';
import { UppOfferStartComponent } from '../components/start/upp-start';
import { UppOfferEditComponent } from '../components/edit/upp-edit';
import { UppOfferItemComponent } from '../components/product/upp-item';
import { UppOfferEditOfferComponent } from '../components/edit/upp-edit';
import { UppOfferEditMenuComponent } from '../components/edit/upp-edit';
import { UppOfferEditDiscountComponent } from '../components/edit/upp-edit';
import { UppDiscountThumbComponent } from '../components/discount/upp-thumb';

@NgModule({
    declarations: [
        UppOfferThumbComponent,
        UppOfferTicketComponent,
        UppOfferStartComponent,
        UppOfferEditComponent,
        UppOfferItemComponent,
        UppOfferEditOfferComponent,
        UppOfferEditMenuComponent,
        UppOfferEditDiscountComponent,
        UppDiscountThumbComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        DragDropModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule,
        FeatureProductModule,
        FeaturePeriodModule        
    ],
    exports: [
        UppOfferThumbComponent,
        UppOfferTicketComponent,
        UppOfferEditComponent,
        UppDiscountThumbComponent
    ],    
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureOfferModule {}
